import React from 'react';
import PropTypes from 'prop-types';
import {SubCategories} from '~/GalleryPB/SubCategories';
import {FilterGroups} from '~/GalleryPB/FilterGroups';

export const SideNav = (props) => (
  <div className="gallery__filters-wrapper">
    <SubCategories group={props.subCategories} />
    <FilterGroups
      filters={props.filters}
      onFilterToggle={(sectionId, filterId, on) => {
        props.onFilterToggle(sectionId, filterId, on, true);
      }}
      onPremiumInfoClick={props.onPremiumInfoClick}
    />
  </div>
);

SideNav.propTypes = {
  subCategories: PropTypes.array.isRequired,
  filters: PropTypes.object.isRequired,
  onFilterToggle: PropTypes.func,
  onPremiumInfoClick: PropTypes.func,
};
